import { AddCourseRecurrence, Course } from '@app/admin/model'

export class AddCourse {
    course: Course;
    courseId: number;
    recurrences: Array<AddCourseRecurrence>;
}
